import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface FM160 {
  fm160_01: string;        // 交運單號 (PK)
  fm160_11: string | null; // 交運日期 (ISO string)
  fm160_12: string;        // 客戶代號
  fm160_13: string;        // 幣別代號
  fm160_14: number;        // 匯率
  fm160_15: string;        // 業務人員代號
  fm160_16: string;        // 部門代號
  fm160_17: number;        // 原幣未稅總額
  fm160_18: number;        // 原幣稅額
  fm160_19: number;        // 台幣未稅總額
  fm160_20: string;        // 入單人員
  fm160_21: string;        // S/C NO.
  fm160_22: string;        // 庫位代號
  fm160_30: number;        // 總項數
  fm160_80: string;        // 狀態 (N/P)
  fm160_91: string;        // 修改人員
  fm160_92: string | null; // 修改日期

  // Associations
  details?: FM161[];
}

export interface FM161 {
  fm161_01: string;  // 交運單號 (FK)
  fm161_02: number;  // 項次
  fm161_11: string;  // 產品代號
  fm161_12: string;  // 批號
  fm161_13: string;  // 顏色代號
  fm161_14: number;  // 交運數量
  fm161_15: number;  // 交運單價
  fm161_16: number;  // 交運金額
  fm161_17: number;  // 單位換算率
  fm161_18: string;  // 交運單位
  fm161_19: number;  // 庫存交運數量
  fm161_20: string;  // 庫存單位
}

export interface ConsignmentShipCreateRequest {
  master: Partial<FM160>;
  details: Partial<FM161>[];
}

export interface ConsignmentShipListResponse {
  data: FM160[];
  total: number;
  page: number;
  size: number;
}

// ============================================================
// API methods
// ============================================================

export const consignmentShipApi = {
  async list(page = 1, size = 20, keyword?: string): Promise<ConsignmentShipListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/consignment-ship', { params });
    return res.data;
  },

  async get(orderNo: string): Promise<FM160> {
    const res = await apiClient.get(`/api/consignment-ship/${encodeURIComponent(orderNo)}`);
    return res.data;
  },

  async create(data: ConsignmentShipCreateRequest): Promise<FM160> {
    const res = await apiClient.post('/api/consignment-ship', data);
    return res.data;
  },

  async update(orderNo: string, data: ConsignmentShipCreateRequest): Promise<FM160> {
    const res = await apiClient.put(`/api/consignment-ship/${encodeURIComponent(orderNo)}`, data);
    return res.data;
  },

  async delete(orderNo: string): Promise<void> {
    await apiClient.delete(`/api/consignment-ship/${encodeURIComponent(orderNo)}`);
  },
};
